<template>
 <div>

  <Row>
   <DatePicker v-model="filterDate" placeholder="Pickup Date"
               :clearable="false" format="dd/MM/yyyy" style="width: 264px; margin-bottom: 7px"></DatePicker>
   <Button style="float: right; margin:-5px 0 6px 0" @click="onAddTempoOrder">Start Day</Button>
   <Button style="float: right; margin:-5px 4px 6px 0" @click="driverListDialog=true">Drivers</Button>
   <Button style="float: right; margin:-5px 4px 6px 0" @click="tempoListDialog=true">Tempos</Button>
  </Row>
  <Table :columns="headers" :data="tempoOrders" size="small" stripe @on-row-click="openTempoOrderDetail" max-height="700">
   <template slot-scope="{ row }" slot="action"
             v-if="moment(filterDate, 'ddd MMMM DD YYYY').format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')">
    <Icon type="md-create" @click.stop="onEditTempoOrder(row)" style="cursor: pointer"></Icon>
    <Icon type="md-close" @click.stop="onDeleteTempoOrder(row)" style="margin-left: 8px;margin-right:12px; cursor: pointer"></Icon>
       <Button v-show="!row.endReading" @click.stop="closeDay(row.id)" type="primary">Close</Button>
   </template>
  </Table>

  <add-tempo-order ref="tempo-order-form"></add-tempo-order>
  <tempo v-if="tempoListDialog"></tempo>
  <driver isLoadedIn="tempoOrders" v-if="driverListDialog"></driver>

  <Drawer :mask-closable="true" class="demo-drawer-prime" title="Tempo Order Detail" v-model="tempoOrderDetailDrawer"
          width="720">
   <Row>
    <Col style="padding-top: 10px" v-if="selectedTempoOrder">
         <Row>
          <h3>Basic Detail | <span style="font-size: medium;font-weight: normal">{{selectedTempoOrder.tempoOrderCode}}</span></h3>
         </Row>
         <Divider></Divider>
         <Row>
          <Col span="12">
           <span style="font-size: 14px; color: #858585">Plate No.</span>
           <p style="margin-bottom: 10px; font-size:17px">{{selectedTempoOrder.tempo.platNo}}</p></Col>
          <Col span="12">
           <span style="font-size: 14px; color: #858585">Driver</span>
           <p style="margin-bottom: 10px; font-size:17px">{{selectedTempoOrder.driverDetail?selectedTempoOrder.driverDetail.name:'-'}}</p>
          </Col>
          <Col span="12">
           <span style="font-size: 14px; color: #858585">Contractor</span>
           <p style="margin-bottom: 10px; font-size:17px">{{selectedTempoOrder.contractor?selectedTempoOrder.contractor.name:'-'}}</p>
          </Col>
         </Row>
     <Divider></Divider>
     <div style="font-weight: bolder;font-size: 14px">
            ORDERS ASSIGNED ({{selectedTempoOrder.orderDetailsArr.length}})</div>
          <Card v-for="(order,index) in selectedTempoOrder.orderDetailsArr" :key="index">
              <b>#{{order.order.orderNumber}}</b><br>
              <b>Dealer</b> : {{order.order.clientobject.name}}<br>
              {{order.order.pickuppartyobject.name}} ↔ {{order.order.droppingpartyobject.name}}<br>
              {{order.order.pickuppartyobject.address[0].city}} ↔ {{order.order.droppingpartyobject.address[0].city}}<br>
              <b>Material</b> : {{order.order.materials.type}} {{order.order.materials.boxes}} boxes | {{order.order.materials.kg}} Kg<br>
              <span v-if="order.lrObject && order.lrObject.lrName"><b>LR No</b> : {{order.lrObject.lrName}}</span><br>
              <span v-if="order.order.note"><b>Note</b> : {{order.order.note}}</span>
          </Card>
          <template v-if="!selectedTempoOrder.orderDetailsArr.length">No Orders assigned yet.</template>
    </Col>
   </Row>
  </Drawer>

 </div>
</template>

<script>
import {GET_TEMPO_ORDERS, GET_OCCUPIED_TEMPOS_AND_DRIVERS} from '../../graphql/queries/tempoOrders'
import {DELETE_TEMPO_ORDER, UPDATE_TEMPOORDER_ENDREADING} from '../../graphql/mutations/tempoOrders'
import {SUBSCRIBE_TEMPO_ORDERS, SUBSCRIBE_OCCUPIED_TEMPOS_AND_DRIVERS} from '../../graphql/subscription/tempoOrders'
import AddTempoOrder from './AddTempoOrder'
import Tempo from '../Settings/Tempo'
import Driver from '../Settings/Driver'
import moment from 'moment'
  export default {
      apollo: {
          tempoOrders: {
              query: GET_TEMPO_ORDERS,
              variables(){
                  return{
                      filterDate : moment(this.filterDate, 'ddd MMMM DD YYYY').format('YYYY-MM-DD')
                  }
              },
              subscribeToMore: {
                  document: SUBSCRIBE_TEMPO_ORDERS,
                  variables(){
                      return{
                          filterDate : moment(this.filterDate, 'ddd MMMM DD YYYY').format('YYYY-MM-DD')
                      }
                  },
                  updateQuery: function(previousResult, { subscriptionData }) {
                      this.tempoOrders = subscriptionData.data.tempoOrders;
                  },
              },
              result ({ data, loading }) {
                  if (!loading) {
                      this.tempoOrders = data.tempoOrders;
                  }
              }
          },
          occupiedTempoAndDriverIds: {
              query: GET_OCCUPIED_TEMPOS_AND_DRIVERS,
              variables(){
                  return {
                      todayDate: moment().format('YYYY-MM-DD')
                  }
              },
              subscribeToMore: {
                  document: SUBSCRIBE_OCCUPIED_TEMPOS_AND_DRIVERS,
                  variables(){
                      return {
                          todayDate: moment().format('YYYY-MM-DD')
                      }
                  },
                  updateQuery: function(previousResult, { subscriptionData }) {
                      this.setTempoIdArrAndDriverIdArr(subscriptionData.data.occupiedTempoAndDriverIds)
                  },
              },
              result ({ data, loading }) {
                  if (!loading) {
                      this.setTempoIdArrAndDriverIdArr(data.occupiedTempoAndDriverIds)

                  }
              }
          },
      },
      name: "TempoOrders",
      components: {Tempo, AddTempoOrder, Driver},
      data: function(){
          return{
              mutation_DELETE_TEMPO_ORDER: DELETE_TEMPO_ORDER,
              mutation_UPDATE_TEMPOORDER_ENDREADING: UPDATE_TEMPOORDER_ENDREADING,
              moment: moment,
              filterDate: moment().format('DD/MM/YYYY'),
              tempoOrders: [],
              headers: [
                  {title: 'Date', key: 'date', width: 115,
                      render:(h, params) => {return h('div',moment(params.row.date).format('DD/MM/YYYY'))}},
                  {title: 'TOCode', key: 'tempoOrderCode', width: 140,
                      renderHeader: function (h) {return h('div', [h('p', 'Tempo Order'), h('p', 'Number')])}},
                  {title: 'Contractor', key: 'contractor',
                      render:(h, params) => {return h('div',params.row.contractor.name)}},
                  {title: 'Tempo', key: 'tempo',
                      render:(h, params) => {return h('div',params.row.tempo.platNo)}},
                  {title: 'Driver', key: 'driverDetail',
                      render:(h, params) => {return h('div',params.row.driverDetail.name)}},
                  {title: 'Start', key: 'startReading', width: 100},
                  {title: 'End', key: 'endReading', width: 100},
                  {title: 'Action', slot: 'action', width: 150},
              ],
              addTempoOrderDrawer: false,
              occupiedTempoIdArr: [],
              occupiedDriverIdArr: [],
              tempoOrderDetailDrawer: false,
              selectedTempoOrder: '',
              endReading: '',
              tempoListDialog: false,
              driverListDialog: false,
          }
      },
      methods: {
          onAddTempoOrder(){
              this.$refs['tempo-order-form'].editMode = false;
              this.addTempoOrderDrawer = true;
          },
          openTempoOrderDetail(rowData, rowindex){
            this.selectedTempoOrder = rowData
            this.tempoOrderDetailDrawer = true
          },
          setTempoIdArrAndDriverIdArr(tempoAndDriverIds){
              if(tempoAndDriverIds.length){
                  let tempoIdArr = [];
                  let driverIdArr = [];
                  tempoAndDriverIds.forEach(function(curnt){
                      tempoIdArr.push(curnt.tempoId);
                      driverIdArr.push(curnt.driverId);
                  })
                  this.occupiedTempoIdArr = tempoIdArr;
                  this.occupiedDriverIdArr = driverIdArr;
              }else{
                  this.occupiedTempoIdArr = [];
                  this.occupiedDriverIdArr = [];
              }
          },
          onEditTempoOrder(row){
              this.$refs['tempo-order-form'].editMode = true;
              this.$refs['tempo-order-form'].setTempoOrderForm(row);
              this.addTempoOrderDrawer = true;
          },
          onDeleteTempoOrder(row){
            this.$refs['tempo-order-form'].onDeleteTempoOrder(row.id);
          },
          closeDay(tempoOrderId){
              this.endReading = '';
              this.$Modal.confirm({
                  title: 'Close Day',
                  render: (h) => {
                      return h('Input', {
                          props: {
                              value: this.endReading,
                              autofocus: true,
                              placeholder: 'Please enter End Reading'
                          },
                          on: {
                              input: (val) => {
                                  this.endReading = val;
                              }
                          }
                      })
                  },
                  onOk: () => {
                      this.updateTempoOrder(tempoOrderId, this.endReading)
                  }
              })
          },
          async updateTempoOrder(tempoOrderId, endReading){
              let response = await this.$apollo.mutate({
                  mutation: this.mutation_UPDATE_TEMPOORDER_ENDREADING,
                  variables: {
                      tempoOrderId: tempoOrderId,
                      endReading: endReading
                  }
              })
              if(response.data){
                  this.$Message.success('Tempo Order updated successfully!');
              }
          },
      }
  }
</script>

<style scoped>
 /deep/ .ivu-table td {
  font-size: 15px;
 }
</style>
